import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ExhibitionPage from "@/pages/ExhibitionPage";
import BoothDetailPage from "@/pages/BoothDetailPage";
import EventSchedulePage from "@/pages/EventSchedulePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ExhibitorDashboard from "@/pages/ExhibitorDashboard";
import CouponRedemptionPage from "@/pages/CouponRedemptionPage";
import RedeemPage from "@/pages/RedeemPage";
import AssistantPage from "@/pages/AssistantPage";
import AssistantBubble from "@/components/AssistantBubble";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ExhibitionPage />} />
          <Route path="/exhibition" element={<ExhibitionPage />} />
          <Route path="/booth/:id" element={<BoothDetailPage />} />
          <Route path="/schedule" element={<EventSchedulePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/exhibitor" element={<ExhibitorDashboard />} />
          <Route path="/exhibitor/redeem" element={<CouponRedemptionPage />} />
          <Route path="/redeem/:code" element={<RedeemPage />} />
          <Route path="/assistant" element={<AssistantPage />} />
        </Routes>
        {/* Floating AI chat bubble available on every page except /assistant (avoids double-panel) */}
        <AssistantBubble />
      </BrowserRouter>
    </div>
  );
}

export default App;
